import React, { useState } from "react";
import { useMutation } from "react-query";
import { useRecoilState } from "recoil";
import { me, update, updatePassword } from "../../Apis";
import Button from "../../Components/Button";
import Error from "../../Components/Modal.Error";
import Success from "../../Components/Modal.Success";
import { userState } from "../../Recoil";

export default function Profile() {
  const [user, setUser] = useRecoilState(userState);
  const [edit, setIsEdit] = useState(false);
  const [current_password, setCurrent] = useState("");
  const [password, setPassword] = useState("");
  const [confirm_password, setConfirmPassword] = useState("");
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);

  const { mutate, isLoading } = useMutation((data) => update(data), {
    onSuccess: (res) => {
      Success(res?.data?.message);
      meMutate();
      setIsEdit(false);
    },
    onError: (err) => Error(err?.response?.data?.message),
  });

  const { mutate: meMutate } = useMutation(() => me(), {
    retry: false,
    onSuccess: (res) => {
      setUser(res?.data?.user);
    },
  });

  const { mutate: updatePasswordMutate, isLoading: passwordUpdateLoading } =
    useMutation((data) => updatePassword(data), {
      onSuccess: (res) => {
        Success(res?.data?.message).then(() => {
          window.location.reload();
        });
      },
      onError: (err) => Error(err?.response?.data?.message),
    });

  return (
    <>
      <section className="p-55-0" style={{ height: "50vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <div className="container">
          <div className="row profile justify-content-center">
            <div className="col-lg-6 col-sm-12">
              <div className="d-flex flex-row justify-content-center">
                <div className="p-2">
                  <p className="ff-thunder fc-lgray">Name</p>
                  {edit ? (
                    <input
                      className="input-cstm p-10-20"
                      onChange={(e) => setUser({ ...user, name: e.target.value })}
                      value={user?.name}
                    />
                  ) : (
                    <p>{user?.name}</p>
                  )}
                </div>
                <div className="p-2">
                  <p className="ff-thunder fc-lgray">Email Address</p>
                  <p>{user?.auth?.email}</p>
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="d-flex flex-sm-column flex-md-row justify-content-center">
                {!edit && (
                  <Button className="btn-pur2 m-1 text-center" onClick={() => setIsPasswordModalOpen(true)}>
                    CHANGE PASSWORD
                  </Button>
                )}
                <Button className="btn-orange m-1" onClick={() => (edit ? mutate({ name: user?.name }) : setIsEdit(!edit))} loading={isLoading}>
                  {edit ? "UPDATE PROFILE" : "EDIT PROFILE"}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>
      {isPasswordModalOpen && (
        <div className="modal fade login-modal show" style={{ display: "block" }}>
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content modal-cstm">
              <div className="modal-header modal-headerClose">
                <button type="button" className="close" onClick={() => setIsPasswordModalOpen(false)}>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body p-20-40">
                <div className="text-center mt-20">
                  <h3 className="ff-thunder fc-purple">Change Password</h3>
                </div>
                <div className="text-left">
                  <div className="row">
                    <div className="col mt-30">
                      <label>Current Password*</label>
                      <input type="password" className="form-control input-cstm" placeholder="Current Password" value={current_password} onChange={(e) => setCurrent(e.target.value)} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col mt-30">
                      <label>New Password*</label>
                      <input type="password" className="form-control input-cstm" placeholder="New Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col mt-30">
                      <label>Confirm Password*</label>
                      <input type="password" className="form-control input-cstm" placeholder="Confirm Password" value={confirm_password} onChange={(e) => setConfirmPassword(e.target.value)} />
                    </div>
                  </div>
                </div>
                <div className="text-center">
                  <div className="row">
                    <div className="col mt-40 text-center mb-20">
                      <Button className="btn-orange" onClick={() => updatePasswordMutate({ current_password, password, confirm_password })} loading={passwordUpdateLoading}>
                        UPDATE
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
